module.exports = __webpack_public_path__ + "img/vision.22f36f38.png";